import { createApi, retry } from '@reduxjs/toolkit/query/react';

import { accountHeaderBaseQuery } from './base-queries/account-header';

const { app } = PULSE;
const { API_RETRY_COUNT } = app.common.CONSTANTS;

// RTK Query update: Define an api service with a base URL and retry attempts
// RTK Query update: Endpoints can be added here or injected in components
export const aflApi = createApi({
    reducerPath: 'aflAPI',
    baseQuery: retry(accountHeaderBaseQuery, { maxRetries: API_RETRY_COUNT }),
    endpoints: (build) => ({
        getCompetitions: build.query({
            query: () => 'competitions?pageSize=50',
            transformResponse: (response) => response?.competitions
        }),
        getTeams: build.query({
            query: (compSeasonId) =>
                `teams?compSeasonId=${compSeasonId}&pageSize=100`,
            transformResponse: (response) => response?.teams
        }),
        getVenues: build.query({
            query: (compSeasonId) => `venues?compSeasonId=${compSeasonId}`,
            transformResponse: (response) => response?.venues
        }),
        getMatches: build.query({
            query: (params) => `matches${app.common.prepareParams(params)}`,
            transformResponse: (response) => response?.matches
        }),
        getLadder: build.query({
            query: ({ compSeasonId, roundId }) =>
                `compseasons/${compSeasonId}/ladders${
                    roundId ? '?roundId=' + roundId : ''
                }`,
            transformResponse: (response) => response?.ladders
        }),
        getRound: build.query({
            query: ({ compseasonId, roundNumber, pageSize }) =>
                `compseasons/${compseasonId}/rounds?roundNumber=${roundNumber}&pageSize=${pageSize}`,
            transformResponse: (response) => response?.rounds[0]?.byes
        })
    })
});

export const {
    useGetCompetitionsQuery,
    useGetTeamsQuery,
    useGetVenuesQuery,
    useGetMatchesQuery,
    useGetLadderQuery,
    useGetRoundQuery
} = aflApi;
